import * as actionTypes from './actionTypes'

const initialState = {
  startDate: null,
  routeName: '-1',
  direction: '-1',
  tripsData: [],
  ticketDetails: [],
  etmRoutes: [],
  directions: []
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.ETM_TICKETS_TRIP_LIST:
      return { ...state, tripsData: payload.data };
    case actionTypes.ETM_TICKET_DETAILS:
      return { ...state, ticketDetails: payload.data }
    case actionTypes.UPDATE_ETM_USER_INPUT_VALUES:
      return { ...state, [payload.fieldName]: payload.value }
    case actionTypes.ETM_ROUTES_LIST:
      return { ...state, etmRoutes: payload.data.routes || [], directions: payload.data.directions || [] }
    case actionTypes.CLEAR_TICKET_DETAILS:
      return { ...state, ticketDetails: [] };
    case actionTypes.CLEAR_ALL_ETM_TICKETS_DATA:
      return initialState;
    default:
      return state
  }
}
